import { getFlightItemsView } from 'checkout/selectors/view/flights'
import { sum } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { getIsEnabledFlightsLuxPlusPricing } from '../featureToggle'

function getFlightRegularPrice(itemView: App.Checkout.FlightItemView): number | undefined {
  const hasLuxPlusRegularPrice = itemView.flights.some(flight =>
    flight.journeyFlight.isLuxPlusFare && !!flight.journeyFlight.regularPrice?.all.totalFare,
  )

  if (!hasLuxPlusRegularPrice) {
    return undefined
  }

  return sum(itemView.flights, flight => {
    if (flight.journeyFlight.isLuxPlusFare && flight.journeyFlight.regularPrice?.all.totalFare) {
      return flight.journeyFlight.regularPrice.all.totalFare
    }

    return flight.cost ?? flight.journeyFlight.cost ?? 0
  })
}

export const getAvailableFlightBenefits = createSelector(
  (state: App.State) => getFlightItemsView(state),
  (state: App.State) => getIsEnabledFlightsLuxPlusPricing(state),
  (flightItemsView, isFlightsLuxPlusPricingEnabled): App.Checkout.BaseDiscountedPricingBenefit => {
    if (!isFlightsLuxPlusPricingEnabled) {
      return {
        totalPrice: 0,
        totalBaseMemberPrice: 0,
        totalMemberPrice: 0,
        totalMemberPriceSavings: 0,
      }
    }

    const totalMemberPriceSavings = sum(flightItemsView.data, itemView => {
      if (itemView.isBundled) {
        return 0
      }

      const regularPrice = getFlightRegularPrice(itemView)
      if (regularPrice === undefined) {
        return 0
      }

      return Math.max(regularPrice - itemView.totals.price, 0)
    })

    return {
      totalPrice: 0,
      totalBaseMemberPrice: 0,
      totalMemberPrice: 0,
      totalMemberPriceSavings,
    }
  },
)
